<div class="glaeSegment">
    <div id="setupRewardsHeader" class="glaeSegmentHeader" cvLocalizedText langSection="Games" langKey="Setup_Rewards_Title_Bracket_Game">Rewards</div>
    <div class="glaeSegmentText" cvLocalizedText langSection="Games" langKey="Setup_Rewards_Bracket_Game">Players will only receive the prize corresponding to their final placement.</div>
    
    <div class="d-flex flex-column" *ngFor="let reward of rewards; let i = index">
        <div class="d-flex mt-4 flex-row font-size-14 font-weight-bold">
                <p>{{ roundsToShow[i] }}</p>
        </div>
        <div class="d-flex flex-row align-items-center">
            <div class="form-check pr-5">
                <input type="radio" class="form-check-input" [name]="'prize'+i" [(ngModel)]="reward.isSystemReward" [value]="true" />
                <label for="rewardType" class="form-check-label font-size-13 color-whaleTail font-weight-bold pr-2" cvLocalizedText langSection="Games" langKey="System_Rewards">System Rewards</label>              
            </div>
            <div>
                <input type="radio" class="form-check-input" [name]="'prize'+i" [(ngModel)]="reward.isSystemReward" [value]="false" />
                <label for="rewardType" class="form-check-label font-size-13 color-whaleTail font-weight-bold pr-2" cvLocalizedText langSection="Games" langKey="Custom_Rewards">Custom Rewards</label>              
            </div>
        </div>
    
        <div class="d-flex flex-row">
            <ng-container *ngIf="reward.isSystemReward; else customReward">
                <div class="mr-4">
                    <div id="Div1" class="font-size-12 mt-2" [ngClass]="{ 'legacy-styles-body-default': isCxone }" cvLocalizedText langSection="Games" langKey="Coin_Reward">Coin Reward</div>
                    <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text px-2 py-0 g-icon g-icon-coin"></span></div>
                        <input type="number" class="form-control no-spinner" cvLocalizedPlaceholder langSection="Games" langKey="Coins" [(ngModel)]="reward.Coins.rewardValue" (blur)="handleRewardBlur(i, $event)">
                    </div>
                </div>
                <div class="mr-4">
                    <div class="font-size-12 mt-2" cvLocalizedText langSection="Games" langKey="XP_Reward">XP Reward</div>
                    <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text px-2 py-0 g-icon g-icon-xp"></span></div>
                        <input type="number" class="form-control no-spinner" cvLocalizedPlaceholder langSection="Games" langKey="XP" [(ngModel)]="reward.XP.rewardValue" (blur)="handleRewardBlur(i, $event)">
                    </div>
                </div>

                    <!-- NOTE: This is in case Gems are added to the rewards in the future.
                    <div class="mr-4"> 
                        <div class="font-size-12 mt-2" cvLocalizedText langSection="Games" langKey="Gems_Reward">Gems Reward</div>
                        <div class="input-group">
                            <div class="input-group-prepend"><span class="input-group-text px-2 py-0 g-icon g-icon-gem"></span></div>
                            <input type="number" class="form-control no-spinner" cvLocalizedPlaceholder langSection="Games" langKey="XP" [(ngModel)]="reward.Gems.rewardValue" (blur)="handleRewardBlur(i, $event)">
                        </div>
                    </div> 
                    -->
                <div>
                    <div class="d-flex align-items-center">
                        <span class="d-block w-100 text-center" [ngClass]="{ 'legacy-styles-body-default': isCxone }" cvLocalizedText langSection="Games" langKey="Badge">Badge</span>
                    </div>
                    <div *ngIf="reward.Badge.rewardValue == 0" (click)="popBadgeSelector(reward);" class="cursor-pointer ">
                        <div class="gamesAddBadgeIcon"></div>
                    </div>
                    <div *ngIf="reward.Badge.rewardValue > 0" (mouseover)="showRemove[i]=true" (mouseleave)="showRemove[i]=false" (click)="popBadgeSelector(reward)" class="cursor-pointer d-flex">
                        <img *ngIf="reward.Badge.rewardValue > 0" [src]="'../Admin/ImageResizer.aspx?imgid=' + reward.Badge.rewardValue + '&w=48&h=48'" />
                        <div class="d-flex" *ngIf="showRemove[i]"  style="margin-left:-5px;">
                            <div (click)="removeBadge(reward.Badge); $event.stopPropagation();" class="removingBadge d-flex justify-content-center align-items-center">
                                <svg style="width:12px; height:12px;" class="fill-white"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
                            </div>
                        </div>
                    </div>
                </div>   
            </ng-container>
    
            <ng-template #customReward>
                <div class="custom-reward pl-0 mt-2 mr-4">
                    <input type="text" class="form-control w-100" [(ngModel)]="reward.Custom.rewardText" (blur)="handleRewardBlur(i, $event)" (change)="onCustomRewardSelected(i)" [attr.list]="'existingCustomRewards'+i" maxlength="50" cvLocalizedPlaceholder langSection="Games" langKey="Custom_Rewards_Placeholder"/>
                    <datalist [id]="'existingCustomRewards'+i">
                        <option *ngFor="let product of getProductList()" [value]="product">
                     </datalist>
                    <p class="pt-2 color-redRyder" *ngIf="reward.Msg.length > 0"> {{reward.Msg}}</p>
                </div>
            </ng-template>
    
            <div [ngClass]="{'mt-4 pt-1': reward.isSystemReward, 'mt-2': !reward.isSystemReward}" [style.marginLeft.px]="reward.isSystemReward ? 48 : 98">
                <svg class="icon-24 fill-valyrianSteel fill-hover-whaleTail" (click)="confirmRemoveReward(reward)"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
            </div>
        </div>
    </div>

    <button *ngIf="roundsToShow.length < rounds " type="button" class="btn btn-text btn-icon mt-2" (click)="addNewPrize();">
        <svg class="icon-16 fill-cerulean"><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
        <span cvLocalizedText langSection="Games" langKey="Add_Prize">Add Prize</span>
    </button>
</div>
